// Curated content on the life of Matsuo Basho (1644–1694)

export const BASHO_INTRO = {
  name: "Matsuo Bashō",
  japanese: "松尾芭蕉",
  years: "1644 — 1694",
  tagline:
    "The wandering master who elevated the hokku into an art of stillness, season, and the fleeting present.",
};

export const BASHO_BIO = [
  "Born Matsuo Kinsaku near Ueno, in Iga Province, Bashō entered the service of the samurai Tōdō Yoshitada, with whom he first shared a love of poetry. When his young lord died, Bashō abandoned the path of the warrior and turned wholly toward verse.",
  "He took his pen name from a bashō (banana) plant gifted by a student, planted beside the modest hut where he lived on the outskirts of Edo. The broad, easily torn leaves became an emblem of his aesthetic: beauty in the fragile and impermanent.",
  "Restless in the city, Bashō set out on a series of arduous journeys on foot across Japan. From these travels came his celebrated poetic travelogues, culminating in Oku no Hosomichi — 'The Narrow Road to the Deep North' — a fusion of prose and haiku that remains a summit of Japanese literature.",
  "Bashō deepened the linked-verse tradition of renga and renku, treating the collaborative chain of verses as a spiritual discipline shared among poets. He died in Osaka in 1694, still travelling, leaving a final verse dreaming of wandering across withered fields.",
];

export const BASHO_TIMELINE = [
  { year: "1644", title: "Birth in Iga", text: "Born near Ueno in Iga Province to a minor samurai family." },
  { year: "1666", title: "A Lord Lost", text: "The death of his master Yoshitada turns Bashō away from samurai life toward poetry." },
  { year: "1672", title: "To Edo", text: "Moves to the booming city of Edo to establish himself as a poet and teacher." },
  { year: "1680", title: "The Bashō Hut", text: "Students build him a riverside hut; a banana plant gives him his enduring name." },
  { year: "1684", title: "First Great Journey", text: "Begins the travels recorded in 'Records of a Weather-Exposed Skeleton'." },
  { year: "1689", title: "The Narrow Road", text: "Sets out on the epic northern journey behind 'Oku no Hosomichi'." },
  { year: "1694", title: "Final Verse", text: "Dies in Osaka; his last poem dreams of wandering withered fields." },
];

export const BASHO_HAIKU = [
  {
    jp: "古池や\n蛙飛びこむ\n水の音",
    romaji: "furuike ya / kawazu tobikomu / mizu no oto",
    en: "An old silent pond—\na frog leaps into the pond,\nsplash! Silence again.",
    note: "The most famous haiku ever written.",
  },
  {
    jp: "夏草や\n兵どもが\n夢の跡",
    romaji: "natsukusa ya / tsuwamonodomo ga / yume no ato",
    en: "Summer grasses—\nall that remains of\nsoldiers' dreams.",
    note: "Written at the ruins of Hiraizumi.",
  },
  {
    jp: "静けさや\n岩にしみ入る\n蝉の声",
    romaji: "shizukesa ya / iwa ni shimiiru / semi no koe",
    en: "Such stillness—\nthe cries of the cicadas\nsink into the rocks.",
    note: "At Risshaku-ji temple.",
  },
  {
    jp: "旅に病んで\n夢は枯野を\nかけ廻る",
    romaji: "tabi ni yande / yume wa kareno wo / kakemeguru",
    en: "Sick on my journey,\nmy dreams go wandering\nover withered fields.",
    note: "His final poem.",
  },
];

export const SEASONS = ["Spring", "Summer", "Autumn", "Winter"];
